import { ReviewStar } from '../../../assets/review-star'

/** Big number with a gold star. (e.g. 4.8[star]) */
export default function ReviewNumber({ rating }: { rating: number }) {
  return (
    <div className="flex flex-row items-end gap-[5px] xs:gap-[3px]">
      <span className="text-[52px] font-bold leading-none tracking-[-0.52px] text-primary">{rating.toFixed(1)}</span>
      <ReviewStar size={25} pattern="gold" className="mb-[5px]" />
    </div>
  )
}
